export default "__VITE_ASSET__C2d7v1Qn__"